import script from "./ResponseFileServerError.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponseFileServerError.vue?vue&type=script&setup=true&lang=js"

import "./ResponseFileServerError.vue?vue&type=style&index=0&id=49365e1b&scoped=true&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\edb_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49365e1b"]])

export default __exports__